<template>
    <div class="tiny-check tappable" @click="triggerClick">
        <i class="fa ok fa-check-square-o" v-if="isTrue" aria-hidden="true"></i>
        <i class="fa fa-square-o" v-else aria-hidden="true"></i>
    </div>
</template>

<script>
export default {
    name: 'tinyCheck',
    props: {
        value: {
            type: [Number, String, Boolean],
            default: false
        }
    },
    computed: {
        isTrue(){
            return (!!this.value && (this.value == true || parseInt(this.value) == 1 || this.value == 'true'))
        }
    },
    methods: {
        triggerClick(){
            this.$emit('input', !this.isTrue)
        }
    }
}
</script>

<style lang="less">
.tiny-check {
    text-align: center;
    i, svg {
        // font-size: 2em;
        transform: scale(2);
        color: var(--secondary);
        &.ok {
            color: var(--primary);
        }
    }
}
</style>